import React from 'react'
import "./sectionPublishAndShare.scss"

//Imagens:
import ImgSectionPublishAndShare from "../../../../assets/publishAndShare/sectionPublishAndShare.png"
import { useTranslation } from 'react-i18next'

function SectionPublishAndShare() {
  const { t } = useTranslation()

  return (
    <div className='container-section-publish-and-share'>
      <div className="img-section-publish-and-share">
        <img src={ImgSectionPublishAndShare} alt="imagem publique e compartilhe" />
      </div>
      <div className="texts-section-publish-and-share">
        <h1>{t("publish_and_share.title")}</h1>
        <p>{t("publish_and_share.section_text")}</p>

        <a href="/form">
          <button id='btn-section-publish-and-share'>{t("buttons.demo_btn_alternative_text_1")}</button>
        </a>
      </div>
    </div>
  )
}

export default SectionPublishAndShare